import React, { useEffect, useRef, useState } from 'react'; 
import { Link, useNavigate } from 'react-router-dom'; 
import { MdDehaze, MdOutlineSportsKabaddi, MdOutlineSportsTennis } from "react-icons/md"; 
import { FaCircleUser } from 'react-icons/fa6';
import { GiCricketBat } from 'react-icons/gi';
import { IoIosFootball, IoMdBasketball } from 'react-icons/io';
import { PiHockeyFill } from 'react-icons/pi';
import { IoBaseball } from 'react-icons/io5';
import _constantUtil from '../../utils/Constant'



function Navbar({buttonRef}) {

  const [themeMode, setThemeMode] = useState('light');
  const [showConfirmation, setShowConfirmation] = useState(_constantUtil.BOOLEAN_FALSE);
  const navigate = useNavigate()


  useEffect(() => {
    const handleThemeToggle = () => {
      const newThemeMode = themeMode === 'light' ? 'dark' : 'light';
      setThemeMode(newThemeMode);
      sessionStorage.setItem('themeMode', newThemeMode);
    };

    const storedThemeMode = sessionStorage.getItem('themeMode');

    if (storedThemeMode) {
      setThemeMode(storedThemeMode);
    } else {
      setThemeMode('light');
    }

    const themeToggleElement = document.getElementById('theme-mode');
    if (themeToggleElement) {
      themeToggleElement.addEventListener('click', handleThemeToggle);
    }

    return () => {
      if (themeToggleElement) {
        themeToggleElement.removeEventListener('click', handleThemeToggle);
      }
    };
  }, [themeMode]);

  useEffect(() => {
    document.documentElement.setAttribute('data-bs-theme', themeMode);
  }, [themeMode]); 
  
  const [menuOpen, setMenuOpen] = useState(_constantUtil.BOOLEAN_FALSE);
  const dropdownRef1 = useRef(_constantUtil.NULL);

  const toggleDropdown = () => {
    setMenuOpen(!menuOpen);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef1.current && !dropdownRef1.current.contains(event.target)) {
      setMenuOpen(_constantUtil.BOOLEAN_FALSE);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
 
  const confirmationRef = useRef(_constantUtil.NULL);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (confirmationRef.current && !confirmationRef.current.contains(event.target)) {
        setShowConfirmation(_constantUtil.BOOLEAN_FALSE);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);


  const [activeSport, setActiveSport] = useState('Cricket');  

  const handleTabClick = (sport) => {
    setActiveSport(sport);
  };

  return (
    <>
      {showConfirmation && (
        <div>
          <div className='confirmation-overlay'></div>
          <div ref={confirmationRef} className='confirmation-dialog'>
            <p>Are you sure to logout from portal ?</p>
            <div className='d-flex justify-content-end'>
              <button onClick={() => setShowConfirmation(_constantUtil.BOOLEAN_FALSE)} className='rounded bg-danger px-3 p-2 text-white border-0'>Cancel</button>
              {/* <button onClick={() => navigate('/logout')} className='rounded bg-success px-3 p-2 text-white border-0'>Confirm</button> use this for when API calling */}
              <button onClick={() => navigate('/')} className='rounded bg-success px-3 p-2 text-white border-0'>Confirm</button>  
            </div>
          </div>
        </div>
      )}
      <div className='navbar-custom'>
        <div className='topbar'>
          <div className='topbar-menu d-flex align-items-center gap-lg-2 gap-1'>  
              <button className='button-toggle-menu ps-0' ref={buttonRef}>
                <MdDehaze />
              </button>
            </div>

            <div className="d-flex sports-tabs">
              {[
                { sport: 'Cricket', icon: <GiCricketBat />, label: 'Cricket' },
                { sport: 'Football', icon: <IoIosFootball />, label: 'Football' },
                { sport: 'Kabaddi', icon: <MdOutlineSportsKabaddi />, label: 'Kabaddi' },
                { sport: 'Basketball', icon: <IoMdBasketball />, label: 'Basketball' },
                { sport: 'Hockey', icon: <PiHockeyFill />, label: 'Hockey' },
                { sport: 'Baseball', icon: <IoBaseball />, label: 'Baseball' },
                { sport: 'Tennis', icon: <MdOutlineSportsTennis />, label: 'Tennis' }
              ].map(({ sport, icon, label }) => (
                <div
                  key={sport}
                  className={`header-link d-flex align-items-center me-2 ${activeSport === sport ? 'header-active' : ''}`}
                  onClick={() => handleTabClick(sport)}
                >
                  {icon}
                  <p className="mb-0 ms-1">{label}</p>
                </div>
              ))}
            </div>


          <ul className='topbar-menu d-flex align-items-center gap-4 ps-0'> 
            <li className='dropdown' ref={dropdownRef1}>
              <a className='nav-link dropdown-toggle nav-user me-0 waves-effect waves-light'
                role='button'
                aria-haspopup='false'
                aria-expanded={menuOpen}
                onClick={toggleDropdown} >
               <FaCircleUser/>
                <span className='ms-1 d-none d-md-inline-block'>
                  Admin 
                </span>
              </a>
              <div className={`dropdown-menu dropdown-menu-end profile-dropdown ${ menuOpen ? 'show' : '' }`}>
                <Link to='/sendemail' className='dropdown-item notify-item'  style={{cursor:'pointer'}}>
                  <i className='fe-log-out' />
                  <span>Password</span>
                </Link>
                <a onClick={()=>{setShowConfirmation(_constantUtil.BOOLEAN_TRUE)}} className='dropdown-item notify-item'  style={{cursor:'pointer'}}>
                  <i className='fe-log-out' />
                  <span>Logout</span>
                </a>
              </div>
            </li>
          </ul>
          
        </div>
      </div>
    </>
  );
}

export default Navbar;
